import { useMutation } from "@tanstack/react-query";
import { uploadAttachment } from "../lib/api-client";

/** Wraps POST /attachments/upload — see compose-sheet.tsx, which tracks each in-flight file's own uploading/done/error state locally rather than through this hook's shared isPending (multiple files can be uploading at once). */
export function useUploadAttachment(mailboxId: string | undefined) {
  return useMutation({
    mutationFn: (file: File) => uploadAttachment(mailboxId!, file),
  });
}
